import { Component, OnInit, Inject, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppService } from '../shared/services/app.service';
import { InventoryService } from './inventory.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { NotifyService } from '../shared/services/notify.service';
import { INotification } from '../shared/interfaces/notification';
import { Observable, Subscription } from 'rxjs/Rx';

@Component({
  selector: 'app-tablet',
  templateUrl: './tablet.component.html',
  styleUrls: ['./tablet.component.css']
})
export class TabletComponent implements OnInit {

  tForm: FormGroup;
  locForm: FormGroup;
  cutForm: FormGroup;
  sawyerForm: FormGroup;
  showScanner:boolean = false;
  barcode:string;
  inventory:any;
  materials: any[] = [];
  suppliers: any[] = [];
  jobs: any[] = [];
  locations: any[] = [];
  colors:any[] = [];
  users:any[] = [];
  showLocForm:boolean = false;
  showCutForm:boolean = false;
  recentlyCut:string;
  showRemnant:boolean = false;
  onSaws:any = {
    saw1:null,
    saw2:null,
    forklift:null
  };
  bigBtns:boolean = true;
  waitingForScanner:string = null;
  waitingForSawyer:string = null;
  showSawyerForm:boolean = false;
  showView:boolean = false;
  private timer;
  private timerSub: Subscription;
  private barcodeSub: Subscription;
  showPrinter: boolean = false;


  constructor(
    @Inject(FormBuilder) fb: FormBuilder,
    private _appService: AppService,
    private _invService: InventoryService,
    private _ref: ChangeDetectorRef,
    private _notifyService: NotifyService
  ) {

    this._appService.showLoader();

    this.sawyerForm = fb.group({
      sawyer: [null]
    });

    this.tForm = fb.group({
      barcode: [null]
    });

    this.locForm = fb.group({
      location: [null],
      onSaw: [null],
      item: [null]
    });

    this.cutForm = fb.group({
      sawName:[null],
      direction: [null],
      length: [null],
      width: [null],
      saw:[null],
      llength:[null],
      lwidth:[null],
      lShape:[false]
    });

  }

  ngOnInit() {

    this._invService.showView$.subscribe(
      v => this.showView = v
    );

    this.barcodeSub = this._invService.barCode$.subscribe(
      b => {
        this.showScanner = false;

        if(this.waitingForScanner !== 'view')
        {
          if((this.onSaws.saw1 && this.onSaws.saw1.barcode == b) || (this.onSaws.saw2 && this.onSaws.saw2.barcode == b) || (this.onSaws.forklift && this.onSaws.forklift.barcode == b)) {
            this._notifyService.setNote({
              styleClass: 'alert-danger',
              heading: 'Oops!',
              body: 'That stone is already on the saw or forklift.'
            });
            return;
          }
        }

        this._appService.showLoader();
        this._invService.getDetail(b).subscribe(
          data => {
            this._appService.hideLoader();
            if(this.waitingForScanner == 'saw1') {
              this._notifyService.setNote({
                styleClass: 'alert-success',
                heading: 'Found It!',
                body: 'Added to EURO'
              });
              data.inventory.location = 'ON SAW';
              data.inventory.saw = 'EURO';
              this.onSaws.saw1 = data.inventory;
              this._invService.moveToSaw(data.inventory).subscribe(
                d => {
                  this.waitingForSawyer = 'saw1';
                  this.showSawyer();
                }
              );
            } else if(this.waitingForScanner == 'saw2') {
              this._notifyService.setNote({
                styleClass: 'alert-success',
                heading: 'Found It!',
                body: 'Added to SASSO'
              });
              data.inventory.location = 'ON SAW';
              data.inventory.saw = 'SASSO';
              this.onSaws.saw2 = data.inventory;
              this._invService.moveToSaw(data.inventory).subscribe(
                d => {
                  this.waitingForSawyer = 'saw2';
                  this.showSawyer();
                }
              );

            } else if(this.waitingForScanner == 'move') {
              this.locForm.reset();
              this.locForm.get('item').setValue(data.inventory);
              this.showLocForm = true;
            } else if(this.waitingForScanner == 'receive') {
              this._invService.received(data.inventory).subscribe(
                d => {
                  this.locForm.reset();
                  this.locForm.get('item').setValue(d.inventory);
                  this.showLocForm = true;
                }
              );

            } else if(this.waitingForScanner == 'view') {


              this.showView = true;
              this._appService.showLoader();
              setTimeout(() => {
                this._invService.viewItem(data.inventory);
                this._appService.hideLoader();
              }, 1000)


            }

          },
          error => {
            this._appService.hideLoader();
            this._notifyService.setNote({
              styleClass: 'alert-danger',
              heading: 'Oops!',
              body: 'We were not able to find that item.'
            });
          }
        );
      }
    );

    this._invService.showScan$.subscribe(
      b => {
        this.showScanner = b;
      }
    );

    this._appService.hideLoader();

    this._invService.getLists().subscribe(
      data => {
        this.jobs = data.lists.jobs;
        this.suppliers = data.lists.suppliers;
        this.suppliers.unshift({name:null});
        this.materials = data.lists.materials;
        this.materials.unshift({name:null, colors:[]});
        this.materials.forEach(function (m) {
          m.colors.unshift({name:null});
        });
        this.locations = data.lists.locations;
        this.locations.unshift({name:null});
        this.users = data.lists.users;
        this.users.unshift({username:null});
      }
    );

    this.getSaws();
    this.timer = Observable.interval(30000);
    this.timerSub = this.timer.subscribe(x => this.getSaws());

    this._appService.showPrintSelection$.subscribe(
      toShow => this.showPrinter = toShow
    );

    this._appService.invSelectedPrinter$.subscribe(
      data => {
        if (this._appService.getPrintFor() == 'tablet') {
          this.finalCut(data)
        }
      }
    );
  }

  ngOnDestroy() {
    this.timerSub.unsubscribe();
    this.barcodeSub.unsubscribe();
  }

  private getSaws() {
    this._invService.getOnSaws().subscribe(
      data => {
        this.onSaws = data.onsaws;
        this._appService.hideLoader();
      }
    );
  }

  viewRecent() {
    this.showLocForm = false;
    this.showCutForm = false;
    if(this.recentlyCut) {
      this.inventory = null;
      this.tForm.get('barcode').setValue(this.recentlyCut);
      this.getDetail();
    }
  }

  getDetail(){
    this.showLocForm = false;
    this.showCutForm = false;
    if(!this.tForm.get('barcode').value) {
      return;
    }
    this._appService.showLoader();
    this._invService.getDetail(this.tForm.get('barcode').value).subscribe(
      data => {
        if(data.inventory) {
          this.inventory = data.inventory;
        } else {
          let n:INotification = {
            styleClass: "alert-danger",
            heading: "Ooops",
            body: "We could not find that item in the inventory"
          };
          this._notifyService.setNote(n);
        }
        this._appService.hideLoader();
      }
    );
  }



  received(item) {
    this.showLocForm = false;
    this.showCutForm = false;
    this._appService.showLoader();
    this._invService.received(item).subscribe(
      data => {
        let n:INotification = {
          styleClass: "alert-success",
          heading: "Received",
          body: "This item has been Received"
        };
        this._notifyService.setNote(n);
        this._appService.hideLoader();
      }
    );
  }

  // print(item) {
  //   this._appService.setPrintItem(item);
  //   this.showPrinter = true;
  // }

  // finalPrint(data) {
  //   const item = this._appService.getPrintItem();
  //   this.showLocForm = false;
  //   this.showCutForm = false;
  //   this._appService.showLoader();
  //   this._invService.printLabel(item, data).subscribe(
  //     data => {
  //       let n:INotification = {
  //         styleClass: "alert-success",
  //         heading: "Printed",
  //         body: "This item has been Printed"
  //       };
  //       this._notifyService.setNote(n);
  //       this._appService.hideLoader();
  //     }
  //   );
  // }

  cut(item) {
    this.showCutForm = true;
    this.showLocForm = false;
  }

  processCut() {
    this._appService.showPrintSelection("tablet");
  }

  finalCut(printer:string) {

    const saw = this.cutForm.get('sawName').value;
    let toCut:any;
    if(saw == 'saw1') {
      toCut = this.onSaws.saw1;
    }
    if(saw == 'saw2') {
      toCut = this.onSaws.saw2;
    }
    const formData = this.cutForm.value;
    this._appService.showLoader();
    this._invService.cut(toCut, formData, saw, printer).subscribe(
      data => {
        let n:INotification = {
          styleClass: "alert-success",
          heading: "Cut",
          body: "A remnant has been created and placed on the forklift."
        };
        this._notifyService.setNote(n);
        this._appService.hideLoader();
        this.showCutForm = false;
        this.onSaws[saw] = null;
        this.onSaws.forklift = data.inventory;
      },
      error => {
        let n:INotification = {
          styleClass: "alert-danger",
          heading: "Oops",
          body: "Remnant could not be created.  Please try again."
        };
        this._notifyService.setNote(n);
        this._appService.hideLoader();
        this.showCutForm = false;
      }
    );
  }

  processSawyer() {

    const saw = this.waitingForSawyer;
    let toCut:any;
    if(saw == 'saw1') {
      toCut = this.onSaws.saw1;
    }
    if(saw == 'saw2') {
      toCut = this.onSaws.saw2;
    }
    const formData = this.sawyerForm.value;
    this._appService.showLoader();
    this._invService.sawyer(toCut, formData).subscribe(
      data => {
        let n:INotification = {
          styleClass: "alert-success",
          heading: "Sawyer",
          body: "Sawyer added to Saw"
        };
        this._notifyService.setNote(n);
        this._appService.hideLoader();
        this.showSawyerForm = false;
        this.onSaws[saw] = data.inventory;
      },
      error => {
        let n:INotification = {
          styleClass: "alert-danger",
          heading: "Oops",
          body: "We could not add that sawyer to the saw."
        };
        this._notifyService.setNote(n);
        this._appService.hideLoader();
        this.showSawyerForm = false;
      }
    );
  }


  move(item) {
    this.showLocForm = true;
    this.showCutForm = false;

  }

  processMove() {
    const onSaw = this.locForm.get('onSaw').value;
    let item = this.locForm.get('item').value;
    if(onSaw) {
      this.onSaws[onSaw] = null;
    }
    item.location = this.locForm.get('location').value;
    item.saw = null;
    this._appService.showLoader();
    this._invService.moveToSaw(item).subscribe(
      data => {
        let n:INotification = {
          styleClass: "alert-success",
          heading: "Moved",
          body: "This item has been Moved"
        };
        this._notifyService.setNote(n);
        this._appService.hideLoader();
        this.showLocForm = false;
      }
    );
  }


  saw1Click() {
    if(this.onSaws.saw1) {
      this.cutForm.reset();
      this.showRemnant = false;
      this.cutForm.get('sawName').setValue('saw1');
      this.showCutForm = true;
    } else {
      this.waitingForScanner = 'saw1';
      this.showScanner = true;
    }
  }

  saw2Click() {
    if(this.onSaws.saw2) {
      this.cutForm.reset();
      this.showRemnant = false;
      this.cutForm.get('sawName').setValue('saw2');
      this.showCutForm = true;
    } else {
      this.waitingForScanner = 'saw2';
      this.showScanner = true;
    }
  }

  isCutStarted():boolean {
    const saw = this.onSaws[this.cutForm.get('sawName').value];
    if(saw && saw.cut && saw.cut.times && saw.cut.times.length ) {
      return saw.cut.times[saw.cut.times.length -1].timeType == 'Start';
    } else {
      return false;
    }
  }

  cutStart() {
    const which = this.cutForm.get('sawName').value;
    let saw = this.onSaws[which];
    saw.cut.times.push({
      timeType: 'Start',
      date: new Date()
    });
    this._invService.startCut(saw).subscribe(
      data => {
        this.showCutForm = false;
        this.cutForm.reset();
        this.onSaws[which] = data.inventory;
      }
    );
  }

  cutStop() {
    const which = this.cutForm.get('sawName').value;
    let saw = this.onSaws[which];
    saw.cut.times.push({
      timeType: 'Stop',
      date: new Date()
    });
    this._invService.stopCut(saw).subscribe(
      data => {
        this.showCutForm = false;
        this.cutForm.reset();
        this.onSaws[which] = data.inventory;
      }
    );
  }

  forkliftClick() {
    if(this.onSaws.forklift) {
      this.locForm.reset();
      this.locForm.get('onSaw').setValue('forklift');
      this.locForm.get('item').setValue(this.onSaws.forklift);
      this.showLocForm = true;
    } else {
      this.waitingForScanner = 'forklift';
      this.showScanner = true;
    }
  }

  moveClick() {

      this.waitingForScanner = 'move';
      this.showScanner = true;

  }

  receiveClick() {

    this.waitingForScanner = 'receive';
    this.showScanner = true;

  }

  viewClick() {

    this.waitingForScanner = 'view';
    this.showScanner = true;

  }

  remove() {
    const saw = this.cutForm.get('sawName').value;
    this.showCutForm = false;
    this.locForm.reset();
    this.locForm.get('onSaw').setValue(saw);
    this.locForm.get('item').setValue(this.onSaws[saw]);
    this.showLocForm = true;
  }

  trash() {
    const saw = this.cutForm.get('sawName').value;
    let toTrash:any;
    if(saw == 'saw1') {
      toTrash = this.onSaws.saw1;
    }
    if(saw == 'saw2') {
      toTrash = this.onSaws.saw2;
    }
    toTrash.cut.date = new Date();
    toTrash.cut.saw = saw;
    this._appService.showLoader();
    this._invService.trash(toTrash).subscribe(
      data => {
        let n:INotification = {
          styleClass: "alert-success",
          heading: "Trashed",
          body: "This item has been trashed"
        };
        this._notifyService.setNote(n);
        if(saw == 'saw1') {
          this.onSaws.saw1 = null;
        }
        if(saw == 'saw2') {
          this.onSaws.saw2 = null;
        }
        this.showCutForm = false;
        this._appService.hideLoader();
      }
    );
  }

  hideLocForm() {
    this.showLocForm = false;
  }

  showSawyer() {
    this.showSawyerForm = true;
  }

  hideSawyer() {
    this.showSawyerForm = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/inventory/tablet.component.ts